export const sleep = ms => new Promise(r => setTimeout(r, ms));
export const sanitizeCell = val => (val == null ? '' : String(val).replace(/[\u200B-\u200F\uFEFF\u00A0\u00AD\u180E\u2060]/g, '').replace(/[\t\r\n]/g, ' ').replace(/\s+/g, ' ').trim());
export const formatDate = d => !d ? '—' : `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
export const fmtNum = n => Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const parseAmountStrict = val => {
  if (val == null || val === '') return NaN;
  let s = String(val).trim().replace(/[₹$€£¥₦₩]/g, '').replace(/,/g, '').replace(/\s/g, '').trim();
  const neg = /^\((.+)\)$/.test(s);
  if (neg) s = s.replace(/^\(|\)$/g, '');
  if (!/^-?\d+(\.\d+)?$/.test(s)) return NaN;
  return neg ? -parseFloat(s) : parseFloat(s);
};
export function parseCSV(text) {
  const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
  return lines.filter(l => l.trim()).map(line => {
    const cols = []; let cur = '', inQ = false;
    for (let i = 0; i < line.length; i++) {
      const c = line[i];
      if (c === '"') { if (inQ && line[i+1] === '"') { cur += '"'; i++; } else inQ = !inQ; }
      else if (c === ',' && !inQ) { cols.push(cur.trim()); cur = ''; } else cur += c;
    }
    cols.push(cur.trim()); return cols;
  });
}
